var _path, _path2, _rect, _circle, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 155,
    height: 106,
    viewBox: "0 0 155 106",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60.5 71.5l71-71.5h-60L0 71.5h60.5z",
    fill: "#1D1D1B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M83.5 92.5l71-71.5h-60L23 92.5h60.5z",
    fill: "#E30613"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 105,
    y: 78.252,
    width: 11.67,
    height: 38.531,
    rx: 5.835,
    transform: "rotate(-45 105 78.252)",
    fill: "#3C3B3B"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.6,
    cx: 82,
    cy: 45,
    r: 31,
    fill: "#000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M73.09 22.646c.258-.307-.118-.684-.457-.448-5.89 4.191-13.955 10.233-15.546 25.16-.045.54.687.71.872.208 3.383-9.63 5.675-14.158 15.131-24.92z",
    fill: "#F6F5F7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M82 83c20.987 0 38-17.013 38-38S102.987 7 82 7 44 24.013 44 45s17.013 38 38 38zm0-7c17.12 0 31-13.88 31-31 0-17.12-13.88-31-31-31-17.12 0-31 13.88-31 31 0 17.12 13.88 31 31 31z",
    fill: "#fff"
  })));
}
SvgSearch.displayName = 'Search';
export default SvgSearch;